import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-right-side",
  imports: [CommonModule],
  templateUrl: "./skeleton-right-side.component.html",
  styleUrl: "./skeleton-right-side.component.scss",
})
export class SkeletonRightSideComponent {}
